<template>
  <div class="service-form">
    <loading v-if="loading" rich></loading>

    <div class="service-form__content">
      <!-- 头部：品牌 + 步骤条 -->
      <div class="service-form__hero">
        <div class="service-form__hero__brand">
          <img class="service-form__hero__logo" src="@/assets/img/official-account/log.png" alt="logo" />
          <div class="service-form__hero__title">售后服务单</div>
          <div class="service-form__hero__subtitle">After-Sales Service</div>
        </div>
        <div class="service-form__hero__steps">
          <div class="service-form__hero__step">
            <img class="service-form__hero__step__img" src="@/assets/img/official-account/Group 74.png" />
            <div class="service-form__hero__step__label">提交工单</div>
          </div>
          <div class="service-form__hero__line"></div>
          <div class="service-form__hero__step">
            <img class="service-form__hero__step__img" src="@/assets/img/official-account/Group 75.png" />
            <div class="service-form__hero__step__label">故障检测</div>
          </div>
          <div class="service-form__hero__line"></div>
          <div class="service-form__hero__step">
            <img class="service-form__hero__step__img" src="@/assets/img/official-account/Group 76.png" />
            <div class="service-form__hero__step__label">返厂维修</div>
          </div>
          <div class="service-form__hero__line"></div>
          <div class="service-form__hero__step">
            <img class="service-form__hero__step__img" src="@/assets/img/official-account/Group 77.png" />
            <div class="service-form__hero__step__label">质检出厂</div>
          </div>
        </div>
      </div>

      <!-- 1. 姓名 -->
      <div class="service-form__group">
        <div class="service-form__label">
          <span class="required">*</span>1. 姓名
        </div>
        <Field v-model="form.name" placeholder="请输入姓名" />
      </div>

      <!-- 2. 联系电话 -->
      <div class="service-form__group">
        <div class="service-form__label">
          <span class="required">*</span>2. 联系电话
        </div>
        <Field v-model="form.phone" type="tel" placeholder="请输入联系电话" />
      </div>

      <!-- 3. 邮箱 -->
      <div class="service-form__group">
        <div class="service-form__label">
          <span class="required">*</span>3. 邮箱
        </div>
        <Field v-model="form.email" type="text" placeholder="请输入邮箱" />
      </div>

      <!-- 4. 单位/机构 -->
      <div class="service-form__group">
        <div class="service-form__label">
          <span class="required">*</span>4. 单位/机构
        </div>
        <Field v-model="form.company" placeholder="请输入单位或机构全称" />
      </div>

      <!-- 5. 工单类型 -->
      <div class="service-form__group">
        <div class="service-form__label">
          <span class="required">*</span>5. 工单类型
        </div>
        <RadioGroup v-model="form.orderType">
          <div v-for="item in orderTypeOptions" :key="item.name" class="service-form__type-item" :class="{
            'service-form__type-item--active': form.orderType === item.name,
          }" @click="form.orderType = item.name">
            <Radio :name="item.name">
              <div class="service-form__type-item__name">{{ item.name }}</div>
              <div class="service-form__type-item__desc">{{ item.desc }}</div>
            </Radio>
          </div>
        </RadioGroup>

        <!-- 许可申请：软件选择 + 机器码 -->
        <template v-if="form.orderType === '许可申请'">
          <div class="service-form__license">
            <div class="service-form__license__label">
              <span class="required">*</span>选择需要授权的软件（可多选）
            </div>
            <CheckboxGroup v-model="form.selectedSoftware" direction="horizontal">
              <Checkbox v-for="sw in softwareOptions" :key="sw" :name="sw" shape="square"
                class="service-form__license__checkbox">{{ sw }}</Checkbox>
            </CheckboxGroup>

            <!-- 根据选择的软件显示对应机器码输入框 -->
            <div v-if="form.selectedSoftware.length > 0" class="service-form__license__codes">
              <div v-for="sw in form.selectedSoftware" :key="sw" class="service-form__license__code-item">
                <Field v-model="form.machineCodes[sw]" :label="sw" placeholder="请输入机器码" @input="
                  form.machineCodes[sw] = form.machineCodes[sw].replace(
                    /[^a-zA-Z0-9\-]/g,
                    ''
                  )
                  " />
              </div>
              <div v-if="false" class="tip-stack">
                <div class="tip-card">
                  <div class="tip-card__icon tip-card__icon--green">
                    <Icon name="description" size="14" />
                  </div>
                  <div class="tip-card__body">
                    <div class="tip-card__title">首次安装</div>
                    <div class="tip-card__desc">
                      安装对应软件包后，获取并复制机器码
                    </div>
                  </div>
                </div>
                <div class="tip-card tip-card--link" @click="showMachineCodeGuide = true">
                  <div class="tip-card__icon tip-card__icon--amber">
                    <Icon name="question" size="14" />
                  </div>
                  <div class="tip-card__body">
                    <div class="tip-card__title">已安装软件包？</div>
                    <div class="tip-card__desc">
                      点击查看机器码所在文件夹位置示意图
                    </div>
                  </div>
                  <Icon class="tip-card__chevron" name="arrow" size="14" />
                </div>
              </div>
              <div class="service-form__micro-notes">
                <div class="service-form__micro-note">首次安装：安装对应软件包后，获取并复制机器码。</div>
                <div class="service-form__micro-note">
                  已安装软件包：
                  <span class="service-form__micro-note__link" @click="showMachineCodeGuide = true">查看机器码位置示意图</span>
                </div>
                <div class="service-form__micro-note">
                  安装包FTP下载地址：<a href="ftp://download.dtcc.tech/" class="service-form__micro-note__link">ftp://download.dtcc.tech/</a>，账号/密码均为：smartsolo
                </div>
              </div>

              <!-- 机器码获取示意图弹窗 -->
              <Popup v-model="showMachineCodeGuide" round closeable position="center" get-container="body"
                :overlay="true" :style="{
                  width: '85%',
                  maxWidth: '340px',
                  maxHeight: '80vh',
                  overflow: 'auto',
                  borderRadius: '12px',
                  zIndex: 3100,
                }">
                <div class="service-form__sn-popup">
                  <div class="service-form__sn-popup__title">
                    如何获取机器码
                  </div>
                  <div class="service-form__sn-popup__desc">
                    在已安装的软件目录中找到
                    solomachinecodegenerator.exe，双击运行即可获取机器码：
                  </div>
                  <img class="service-form__sn-popup__img service-form__sn-popup__img--zoom"
                    src="@/assets/img/official-account/machine-code-guide1.png" alt="SoloLite机器码获取"
                    @click="previewMachineCodeImages(0)" />
                  <div class="service-form__sn-popup__desc" style="margin-top: 10px">
                    SmartSoloApps 目录示例：
                  </div>
                  <img class="service-form__sn-popup__img service-form__sn-popup__img--zoom"
                    src="@/assets/img/official-account/machine-code-guide2.png" alt="SmartSoloApps机器码获取"
                    @click="previewMachineCodeImages(1)" />
                  <div class="service-form__sn-popup__tip">
                    运行 solomachinecodegenerator.exe 后复制生成的机器码
                  </div>
                </div>
              </Popup>
            </div>
          </div>
        </template>
      </div>

      <!-- 6. 设备信息 -->
      <div class="service-form__group">
        <div class="service-form__label">6. 设备信息</div>

        <!-- 提示信息（2026 现代 App 风格） -->
        <div v-if="false" class="tip-stack">
          <div class="tip-card tip-card--link" @click="showSnGuide = true">
            <div class="tip-card__icon tip-card__icon--green">
              <Icon name="question" size="14" />
            </div>
            <div class="tip-card__body">
              <div class="tip-card__title">如何查看检波器串序列号？</div>
              <div class="tip-card__desc">
                其他设备可通过机身的标签纸内容查找序列号
              </div>
            </div>
            <Icon class="tip-card__chevron" name="arrow" size="14" />
          </div>

          <div class="tip-card tip-card--warn">
            <div class="tip-card__icon tip-card__icon--amber">
              <Icon name="warning" size="14" />
            </div>
            <div class="tip-card__body">
              <div class="tip-card__title">附件上传规则</div>
              <div class="tip-card__desc">
                每个设备模块上传附件 总计 ≤ 20MB
              </div>
            </div>
          </div>
        </div>
        <div class="service-form__micro-notes">
          <div class="service-form__micro-note">
            如何查看检波器串序列号？
            <span class="service-form__micro-note__link" @click="showSnGuide = true">查看说明</span>
          </div>
        </div>

        <!-- 序列号示意图弹窗 -->
        <Popup v-model="showSnGuide" round closeable position="center" get-container="body" :overlay="true" :style="{
          width: '85%',
          maxWidth: '340px',
          maxHeight: '80vh',
          overflow: 'auto',
          borderRadius: '12px',
          zIndex: 3100,
        }">
          <div class="service-form__sn-popup">
            <div class="service-form__sn-popup__title">如何查找序列号</div>
            <div class="service-form__sn-popup__desc">
              序列号（SN）位于检波器串线缆标签上，如下图标注位置：
            </div>
            <img class="service-form__sn-popup__img service-form__sn-popup__img--zoom"
              src="@/assets/img/official-account/sn-guide.png" alt="序列号查找示意图" @click="previewSnImage" />
            <div class="service-form__sn-popup__tip">
              如仍无法找到，请选择"无序列号"并上传设备照片
            </div>
          </div>
        </Popup>

        <!-- 设备列表 -->
        <div v-for="(item, index) in form.serialItems" :key="index" class="service-form__serial-item">
          <div class="service-form__serial-item__header">
            <span class="service-form__serial-item__index">设备 {{ index + 1 }}</span>
            <Icon v-if="form.serialItems.length > 1" name="cross" class="service-form__serial-item__delete"
              @click="removeSerial(index)" />
          </div>

          <!-- 仪器型号（每个设备独立选择） -->
          <div class="service-form__select" @click="openModelPicker(index)">
            <span :class="{ placeholder: !item.deviceModel }">
              {{ item.deviceModel || "请选择仪器型号" }}
            </span>
            <Icon name="arrow-down" />
          </div>
          <div v-if="item.deviceModel === '其他'" style="margin-top: 8px">
            <Field v-model="item.otherModel" placeholder="请填写您的仪器型号" />
          </div>

          <!-- 有/无序列号选择 -->
          <RadioGroup v-model="item.hasSerial" direction="horizontal" class="service-form__serial-radio"
            style="margin: 8px 0">
            <Radio name="yes" class="service-form__radio">有序列号</Radio>
            <Radio name="no" class="service-form__radio">无序列号</Radio>
          </RadioGroup>

          <!-- 有序列号：显示 SN 码输入 -->
          <Field v-if="item.hasSerial === 'yes'" v-model="item.serialNo" label="SN码（序列号）" type="digit"
            :placeholder="isLicenseApply ? '请输入SN码（选填）' : '请输入SN码（必填）'"
            :required="!isLicenseApply" />

          <!-- 故障描述（许可申请时为选填） -->
          <Field v-model="item.faultDesc" label="故障描述" type="textarea" rows="2"
            :placeholder="isLicenseApply ? '请描述故障情况（选填）' : '请描述故障情况（必填）'"
            :required="!isLicenseApply" />

          <!-- 附件上传 -->
          <div class="service-form__serial-item__upload">
            <div class="service-form__serial-item__upload__label">
              故障图片/视频
              <span v-if="!isLicenseApply && item.hasSerial === 'no'" class="required">*（无序列号时必传）</span>
            </div>
            <div class="uploader-wrap" @click.capture="interceptUploaderClick($event, item)">
              <Uploader v-model="item.attachments" :max-count="3" accept="image/*,video/*" result-type="file"
                :before-read="(f) => checkAttachmentSize(f, item)" :after-read="afterReadFile"
                :preview-full-image="false" @click-preview="onClickAttachment" @delete="onDeleteAttachment" multiple
                deletable />
            </div>
          </div>
        </div>

        <div class="service-form__micro-note service-form__micro-note--warn">
          附件上传：图片清晰，每个设备模块上传附件，总计 ≤ 20MB
        </div>
        <div class="service-form__add-btn" @click="addSerial">
          <Icon name="plus" size="14" />
          <span>添加更多设备</span>
        </div>
      </div>

      <!-- 7. 客户备注 -->
      <div class="service-form__group">
        <div class="service-form__label">7. 客户备注</div>
        <Field v-model="form.remark" type="textarea" rows="3" placeholder="其他需要补充说明的内容（选填）" />
      </div>

      <!-- 回寄地址 -->
      <div class="service-form__group">
        <div class="service-form__label">8. 回寄地址</div>
        <div class="service-form__address" @click="pushAddress">
          <div class="service-form__address__info" v-if="address.id">
            <div class="service-form__address__line">
              {{ address.province }}{{ address.city }}{{ address.county }}
            </div>
            <div class="service-form__address__line" style="margin-top: 4px">
              {{ address.detail }}
            </div>
            <div class="service-form__address__contact">
              {{ address.name }} &nbsp;&nbsp;{{ address.tel }}
            </div>
          </div>
          <div v-else class="service-form__address__empty">
            <span>点击选择检修后寄回的地址</span>
          </div>
          <Icon name="arrow" />
        </div>
      </div>

      <!-- 温馨提示 -->
      <div class="service-form__tips">
        <div class="service-form__tips__title">温馨提示：</div>
        <div class="service-form__tips__list">
          <div class="service-form__tips__list__item">
            <span class="service-form__tips__list__dot"></span>
            <span>工单提交成功后，售后服务人员将在1-2个工作日内与您联系；</span>
          </div>
          <div class="service-form__tips__list__item">
            <span class="service-form__tips__list__dot"></span>
            <span><b>面元科学仪器将核查您的服务保障范围，具体维修方案及最终服务费用以售后服务人员检测结果为准；</b></span>
          </div>
        </div>
        <div class="service-form__tips__note">
          注：以上内容仅供参考，最终解释权归面元科学仪器所有。
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="service-form__footer">
      <div class="service-form__footer__draft"
        :class="{ 'service-form__footer__draft--disabled': loading }"
        @click="!loading && saveDraft()">保存草稿</div>
      <div class="service-form__footer__submit"
        :class="{ 'service-form__footer__submit--loading': loading }"
        @click="!loading && submitForm()">
        <Loading v-if="loading" type="spinner" size="16" color="#fff" />
        <span>{{ loading ? "提交中…" : "提交" }}</span>
      </div>
    </div>

    <!-- 仪器型号选择弹窗（放在最外层避免层级问题） -->
    <Popup v-model="showModelPicker" position="bottom" round :style="{ zIndex: 3000 }">
      <Picker :columns="modelOptions" @confirm="onModelConfirm" @cancel="showModelPicker = false" show-toolbar
        title="选择仪器型号" />
    </Popup>

    <!-- 微信环境下的上传选择 action sheet -->
    <ActionSheet v-model="showUploadSheet" :actions="uploadSheetActions" cancel-text="取消" close-on-click-action
      @select="onUploadActionSelect" :round="true" />
  </div>
</template>

<script>
import {
  Field,
  Icon,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Picker,
  Popup,
  Uploader,
  Toast,
  ImagePreview,
  ActionSheet,
  Dialog,
  Loading,
} from "vant";
import {
  createNewAftersale,
  saveDraft as saveDraftApi,
  getDraft as getDraftApi,
} from "@/api/officialAccount/index.js";
import { initOpenid, initCodeApi } from "@/utils/getOpenid";
import {
  ensureWxConfig,
  isWxEnv,
  chooseImage,
  getLocalImgData,
  dataUrlToBlob,
} from "@/utils/wxSdk";
import { cloneDeep } from "lodash";

// 初始表单工厂：data() 与 resetForm 共用，保证"新建"和"提交后清空"形态一致
const createInitialForm = () => ({
  name: "",
  phone: "",
  email: "",
  company: "",
  orderType: "",
  deviceModel: "",
  otherModel: "",
  hasSerial: "yes",
  serialItems: [
    {
      serialNo: "",
      faultDesc: "",
      attachments: [],
      hasSerial: "yes",
      deviceModel: "",
      otherModel: "",
    },
  ],
  noSerialDesc: "",
  noSerialAttachments: [],
  remark: "",
  selectedSoftware: [],
  machineCodes: { SoloLite: "", DMC: "" },
});

export default {
  // 必须显式声明 name，App.vue 里 <keep-alive include="appraise"> 才能匹配到
  name: "appraise",
  components: {
    Field,
    Icon,
    Radio,
    RadioGroup,
    Checkbox,
    CheckboxGroup,
    Picker,
    Popup,
    Uploader,
    ActionSheet,
    Loading,
  },
  data() {
    return {
      loading: false,
      showModelPicker: false,
      showSnGuide: false,
      currentModelIndex: null,
      showMachineCodeGuide: false,
      // WeChat JSSDK 上传 action sheet
      showUploadSheet: false,
      uploadSheetActions: [
        { name: "拍照", color: "#60bb46" },
        { name: "从相册选择图片" },
        { name: "上传视频（打开系统文件）" },
      ],
      uploadTargetItem: null,
      wxReady: false,
      form: createInitialForm(),
      orderTypeOptions: [
        {
          name: "技术咨询",
          desc: "操作指导、参数设置、软件使用疑问、固件升级等，无需寄回仪器",
        },
        {
          name: "故障报修",
          desc: "仪器出现异常、报错、性能下降，需远程诊断或返厂检修",
        },
        {
          name: "许可申请",
          desc: "软件授权申请、特殊权限开通等",
        },
      ],
      softwareOptions: ["SoloLite", "DMC"],
      modelOptions: [
        "IGU-16 5Hz",
        "IGU-16 10Hz",
        "IGU-16HR 5Hz",
        "IGU-16HR 10Hz",
        "IGU-16HR 3C 5Hz",
        "IGU-16HR 3C 10Hz",
        "IGU-16HR 3C 2Hz",
        "IGU-16HR 3C AIO 5Hz",
        "IGU-BD3C-5",
        "TB记录仪",
        "IMU-3C(4G)",
        "IMU-3C(4G) Pro",
        "IMU-3C(ETH)",
        "M1000",
        "其他",
      ],
    };
  },
  computed: {
    address() {
      return this.$store.state.offici.address || {};
    },
    // 许可申请：第 6 项「设备信息」全部变成选填
    isLicenseApply() {
      return this.form.orderType === "许可申请";
    },
  },
  created() {
    // 开发环境跳过微信授权
    if (process.env.NODE_ENV === "development") {
      if (!localStorage.getItem("openId")) {
        localStorage.setItem("openId", "dev_test_openid");
      }
    } else {
      if (!localStorage.getItem("openId")) {
        initOpenid();
      }
      if (
        localStorage.getItem("openId") &&
        localStorage.getItem("openId") === "null"
      ) {
        initCodeApi();
      }
    }
    // 恢复草稿
    this.loadDraft();
  },
  mounted() {
    // iOS 微信 WebView 调用相机时会因内存压力 kill 页面并重载，
    // 通过监听 visibilitychange/pagehide 在页面进入后台前自动保存表单
    this._autoSaveHandler = () => {
      this.saveFormToLocal();
    };
    document.addEventListener("visibilitychange", this._autoSaveHandler);
    window.addEventListener("pagehide", this._autoSaveHandler);

    // 微信环境下初始化 JSSDK（后端提供签名接口）
    if (isWxEnv() && process.env.NODE_ENV !== "development") {
      ensureWxConfig()
        .then(() => {
          this.wxReady = true;
        })
        .catch((err) => {
          this.wxReady = false;
          console.warn("微信 JSSDK 初始化失败，已回退到原生上传：", err);
        });
    }
  },
  beforeDestroy() {
    if (this._autoSaveHandler) {
      document.removeEventListener("visibilitychange", this._autoSaveHandler);
      window.removeEventListener("pagehide", this._autoSaveHandler);
    }
  },
  methods: {
    // === 示意图点击放大预览 ===
    previewMachineCodeImages(startPosition) {
      ImagePreview({
        images: [
          require("@/assets/img/official-account/machine-code-guide1.png"),
          require("@/assets/img/official-account/machine-code-guide2.png"),
        ],
        startPosition,
        closeable: true,
      });
    },
    previewSnImage() {
      ImagePreview({
        images: [require("@/assets/img/official-account/sn-guide.png")],
        closeable: true,
      });
    },

    // === 点击附件（图片）放大预览
    // 自己拦截 click，绕开 Vant Uploader 内置的 onPreviewImage ===
    onClickAttachment(file) {
      // 视频走不到这里（Vant 对非图片文件不触发 click-preview）
      const src = file.content || file.url;
      if (!src) {
        return;
      }
      // 收集当前设备的所有图片，支持左右滑切
      let images = [];
      let startPosition = 0;
      for (const item of this.form.serialItems) {
        const list = (item.attachments || []).filter(
          (a) =>
            (a.file && a.file.type && a.file.type.indexOf("image/") === 0) ||
            (a.content &&
              typeof a.content === "string" &&
              a.content.indexOf("blob:") === 0)
        );
        if (list.indexOf(file) > -1) {
          const srcList = list.map((a) => a.content || a.url).filter(Boolean);
          startPosition = Math.max(0, srcList.indexOf(src));
          images = srcList;
          break;
        }
      }
      if (images.length === 0) {
        images = [src];
      }
      ImagePreview({
        images,
        startPosition,
        closeable: true,
      });
    },

    // === 序列号动态操作 ===
    addSerial() {
      this.form.serialItems.push({
        serialNo: "",
        faultDesc: "",
        attachments: [],
      });
    },
    removeSerial(index) {
      this.form.serialItems.splice(index, 1);
    },

    // === 仪器型号选择 ===
    openModelPicker(index) {
      this.currentModelIndex = index;
      this.showModelPicker = true;
    },
    onModelConfirm(value) {
      if (
        this.currentModelIndex !== null &&
        this.currentModelIndex !== undefined
      ) {
        this.$set(
          this.form.serialItems[this.currentModelIndex],
          "deviceModel",
          value
        );
        if (value !== "其他") {
          this.$set(
            this.form.serialItems[this.currentModelIndex],
            "otherModel",
            ""
          );
        }
      }
      this.showModelPicker = false;
    },

    // === 计算所有设备附件总大小 ===
    // === 计算所有附件总大小 ===
    getTotalAttachmentSize() {
      let total = 0;
      this.form.serialItems.forEach((item) => {
        (item.attachments || []).forEach((a) => {
          if (a.file && a.file.size) {
            total += a.file.size;
          }
        });
      });
      return total;
    },
    // === 从附件列表中移除文件 ===
    removeAttachments(files) {
      files.forEach((f) => {
        if (f.content && f.content.indexOf && f.content.indexOf("blob:") === 0) {
          URL.revokeObjectURL(f.content);
        }
        if (f.url && f.url.indexOf && f.url.indexOf("blob:") === 0) {
          URL.revokeObjectURL(f.url);
        }
        this.form.serialItems.forEach((item) => {
          const idx = (item.attachments || []).indexOf(f);
          if (idx > -1) item.attachments.splice(idx, 1);
        });
      });
    },

    // === Vant Uploader 的 × 按钮回调：释放 blob URL 避免内存泄漏 ===
    // 微信 WebView 内存紧，每个 blob URL 不手动 revoke 浏览器不会自动回收底下的 blob
    onDeleteAttachment(file) {
      if (
        file &&
        file.content &&
        typeof file.content === "string" &&
        file.content.indexOf("blob:") === 0
      ) {
        URL.revokeObjectURL(file.content);
      }
    },

    // === 为图片生成预览 URL
    // blob URL 存入 f.content（前端显示用），
    // f.url 保留给 uploadToServer 写入服务端路径（后端提交用），
    // 两个字段职责分开，避免上传成功后 url 被覆盖导致预览失效。
    // Vant 的缩略图优先级：item.content || item.url，所以 content 自动生效。
    generateImagePreview(f) {
      return new Promise((resolve) => {
        if (!f.file || !f.file.type || f.file.type.indexOf("image/") !== 0) {
          resolve();
          return;
        }
        // 先用原图 blob URL 兜底（Canvas 压缩失败也能显示）
        try {
          const fallbackUrl = URL.createObjectURL(f.file);
          this.$set(f, "content", fallbackUrl);
        } catch (e) {
          // ignore: createObjectURL 在极少数环境不可用
        }

        const reader = new FileReader();
        reader.onerror = () => resolve();
        reader.onload = () => {
          const img = new Image();
          img.onerror = () => resolve();
          img.onload = () => {
            try {
              const MAX = 1280;
              let w = img.naturalWidth;
              let h = img.naturalHeight;
              if (!w || !h) {
                resolve();
                return;
              }
              if (w > MAX || h > MAX) {
                const ratio = Math.min(MAX / w, MAX / h);
                w = Math.max(1, Math.floor(w * ratio));
                h = Math.max(1, Math.floor(h * ratio));
              }
              const canvas = document.createElement("canvas");
              canvas.width = w;
              canvas.height = h;
              const ctx = canvas.getContext("2d");
              ctx.fillStyle = "#fff";
              ctx.fillRect(0, 0, w, h);
              ctx.drawImage(img, 0, 0, w, h);
              if (canvas.toBlob) {
                canvas.toBlob(
                  (blob) => {
                    if (blob) {
                      const compressedUrl = URL.createObjectURL(blob);
                      // 释放原图 blob URL，改用压缩后的
                      if (f.content && f.content.indexOf("blob:") === 0) {
                        URL.revokeObjectURL(f.content);
                      }
                      this.$set(f, "content", compressedUrl);
                      // 同步缓存一份压缩后 base64，跨刷新/跨会话还能恢复缩略图
                      this.cachePendingContent(f, blob);
                    }
                    resolve();
                  },
                  "image/jpeg",
                  0.75
                );
              } else {
                resolve();
              }
            } catch (e) {
              resolve();
            }
          };
          img.src = reader.result;
        };
        reader.readAsDataURL(f.file);
      });
    },

    // === 把后端返回的相对路径（如 "aftersale/xxx.jfif"）拼成可访问的绝对路径 ===
    // 后端存储的 url 格式是 API 相对路径，前端需加 API base（/api）才能 <img> 加载
    resolveAttachmentUrl(url) {
      if (!url || typeof url !== "string") return url;
      if (/^https?:/.test(url)) return url;
      if (url.charAt(0) === "/") return url;
      const base = this.GLOBAL.ssoServer; // dev:"api"  prod:"/api"
      const prefix = base.charAt(0) === "/" ? base : "/" + base;
      return prefix + "/" + url;
    },

    // === Canvas 压缩 blob：降到 maxDim 边长、jpeg quality，缓解 iOS WebView 内存压力 ===
    // wx.chooseImage 虽然已经 compressed，实际大小 1-3MB，多张叠加 iOS 调相机仍会被杀
    compressBlob(blob, maxDim = 1280, quality = 0.75) {
      return new Promise((resolve) => {
        const tempUrl = URL.createObjectURL(blob);
        const img = new Image();
        img.onerror = () => {
          URL.revokeObjectURL(tempUrl);
          resolve(blob); // 失败时降级返回原图
        };
        img.onload = () => {
          try {
            let w = img.naturalWidth;
            let h = img.naturalHeight;
            if (!w || !h) {
              URL.revokeObjectURL(tempUrl);
              resolve(blob);
              return;
            }
            if (w > maxDim || h > maxDim) {
              const ratio = Math.min(maxDim / w, maxDim / h);
              w = Math.max(1, Math.floor(w * ratio));
              h = Math.max(1, Math.floor(h * ratio));
            }
            const canvas = document.createElement("canvas");
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext("2d");
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, w, h);
            ctx.drawImage(img, 0, 0, w, h);
            if (canvas.toBlob) {
              canvas.toBlob(
                (newBlob) => {
                  URL.revokeObjectURL(tempUrl);
                  resolve(newBlob || blob);
                },
                "image/jpeg",
                quality
              );
            } else {
              URL.revokeObjectURL(tempUrl);
              resolve(blob);
            }
          } catch (e) {
            URL.revokeObjectURL(tempUrl);
            resolve(blob);
          }
        };
        img.src = tempUrl;
      });
    },

    // === 每个设备模块附件体积校验（新增/WX/视频三个入口都用同一套） ===
    // 规则：单个设备所有附件加起来 ≤ 20MB
    getAttachmentTotalBytes(attachments) {
      return (attachments || []).reduce((sum, a) => {
        const size = (a.file && a.file.size) || 0;
        return sum + size;
      }, 0);
    },
    // Vant Uploader 的 before-read：返回 false 取消加入，返回 true/Promise.resolve 继续
    checkAttachmentSize(fileOrFiles, item) {
      const files = Array.isArray(fileOrFiles) ? fileOrFiles : [fileOrFiles];
      const incoming = files.reduce((sum, f) => {
        const size = (f && f.file && f.file.size) || (f && f.size) || 0;
        return sum + size;
      }, 0);
      const current = this.getAttachmentTotalBytes(item.attachments);
      const LIMIT = 20 * 1024 * 1024;
      if (current + incoming > LIMIT) {
        Toast("每个设备模块附件总计不能超过 20MB");
        return false;
      }
      return true;
    },

    // === 附件上传到后端服务器 ===
    async afterReadFile(file) {
      const files = Array.isArray(file) ? file : [file];

      // 生成图片预览
      await Promise.all(files.map((f) => this.generateImagePreview(f)));

      // 上传到服务器
      for (let i = 0; i < files.length; i++) {
        await this.uploadToServer(files[i]);
      }
    },

    // === 拦截 Uploader "+" 按钮点击 ===
    // 在微信环境下拦截默认的 <input type=file>，改为显示我们自己的 ActionSheet
    // 这样图片走 wx.chooseImage（原生能力，不会触发 iOS 页面刷新），
    // 视频仍走 HTML input（wx.chooseVideo 限制太多，不适合售后场景）
    interceptUploaderClick(e, item) {
      if (!this.wxReady) return;
      const target = e.target;
      // 只拦截"+"按钮的点击，不拦截现有附件的预览/删除
      const uploadBtn =
        target &&
        target.closest &&
        target.closest(".van-uploader__upload");
      if (!uploadBtn) return;
      e.preventDefault();
      e.stopPropagation();
      this.uploadTargetItem = item;
      this.showUploadSheet = true;
    },

    // === ActionSheet 选项处理 ===
    onUploadActionSelect(action, index) {
      this.showUploadSheet = false;
      if (!this.uploadTargetItem) return;
      const item = this.uploadTargetItem;
      this.uploadTargetItem = null;
      if (index === 0) {
        // 拍照
        this.handleWxChooseImage(item, ["camera"]);
      } else if (index === 1) {
        // 从相册选择图片
        this.handleWxChooseImage(item, ["album"]);
      } else if (index === 2) {
        // 上传视频（打开系统文件）
        this.triggerVideoInput(item);
      }
    },

    // === 把压缩后的 blob 读成 base64 缓存在 fileItem 上 ===
    // 用途：saveFormToLocal 直接拿它做跨刷新/跨会话的缩略图，纯前端，不依赖后端图片可达
    // 一张约 300KB，3 设备×3 张 ≈ 2.7MB，未触及 localStorage 5MB 配额
    cachePendingContent(fileItem, blob) {
      try {
        const reader = new FileReader();
        reader.onload = () => {
          this.$set(fileItem, "pendingContent", reader.result);
        };
        reader.readAsDataURL(blob);
      } catch (e) {
        console.warn("cachePendingContent 失败", e);
      }
    },

    // === 通过 wx.chooseImage 选择图片并上传 ===
    async handleWxChooseImage(item, sourceType) {
      const remaining = 3 - (item.attachments || []).length;
      if (remaining <= 0) {
        Toast("每个设备最多 3 个附件");
        return;
      }
      let res;
      try {
        res = await chooseImage({
          count: Math.min(9, remaining),
          sizeType: ["compressed"],
          sourceType,
        });
      } catch (err) {
        if (err && err.cancelled) return;
        Toast.fail("调起相机失败，请重试");
        console.warn(err);
        return;
      }
      const localIds = (res && res.localIds) || [];
      for (const localId of localIds) {
        let dataUrl;
        try {
          dataUrl = await getLocalImgData(localId);
        } catch (err) {
          console.warn("getLocalImgData 失败", err);
          continue;
        }
        if (!dataUrl) continue;
        // 先把原图转 blob，然后立刻压缩并丢弃原 blob 和 dataUrl，
        // 保证内存里每张图只留一份 ~300KB 压缩版，iOS 调相机时有足够空闲内存
        let rawBlob = dataUrlToBlob(dataUrl);
        dataUrl = null;
        const blob = await this.compressBlob(rawBlob);
        rawBlob = null;
        const previewUrl = URL.createObjectURL(blob);
        const fileItem = {
          file: new File([blob], "wx_image_" + Date.now() + ".jpg", {
            type: "image/jpeg",
          }),
          content: previewUrl,
          status: "uploading",
          message: "0%",
        };
        // 校验：加上这张还能不能在 20MB 以内
        if (!this.checkAttachmentSize(fileItem, item)) {
          URL.revokeObjectURL(previewUrl);
          break;
        }
        if (!item.attachments) item.attachments = [];
        item.attachments.push(fileItem);
        // 缓存一份压缩后的 base64：iOS 可能在上传完成前刷掉页面，
        // saveFormToLocal 拿它做跨会话预览，让用户知道哪张需要重传
        this.cachePendingContent(fileItem, blob);
        // 走原有上传逻辑
        await this.uploadToServer(fileItem);
      }
    },

    // === 触发隐藏的 video input 做视频上传 ===
    triggerVideoInput(item) {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "video/*";
      input.style.position = "fixed";
      input.style.top = "-9999px";
      input.onchange = async () => {
        const file = input.files && input.files[0];
        if (!file) {
          document.body.removeChild(input);
          return;
        }
        const fileItem = {
          file,
          status: "uploading",
          message: "0%",
        };
        // 校验：加上这个视频还能不能在 20MB 以内
        if (!this.checkAttachmentSize(fileItem, item)) {
          document.body.removeChild(input);
          return;
        }
        if (!item.attachments) item.attachments = [];
        item.attachments.push(fileItem);
        await this.uploadToServer(fileItem);
        document.body.removeChild(input);
      };
      document.body.appendChild(input);
      input.click();
    },
    uploadToServer(file) {
      return new Promise((resolve) => {
        this.$set(file, "status", "uploading");
        this.$set(file, "message", "0%");

        const formData = new FormData();
        formData.append("file", file.file);

        const baseUrl = this.GLOBAL.ssoServer;
        const xhr = new XMLHttpRequest();
        xhr.timeout = 300000;

        xhr.upload.onprogress = (e) => {
          if (e.lengthComputable) {
            const percent = Math.round((e.loaded / e.total) * 100);
            this.$set(file, "message", percent + "%");
          }
        };

        xhr.onload = () => {
          try {
            const data = JSON.parse(xhr.responseText);
            if (data && data.data && typeof data.data === "object" && data.data.fileId) {
              data.data = data.data.fileId;
            }
            if (data.code === "0000000" && data.data) {
              this.$set(file, "status", "done");
              this.$set(file, "message", "");
              // file.url 保留后端返回的相对路径，给 buildSubmitData 提交用
              this.$set(file, "url", data.data.url || data.data);
              // 注意：不主动改 file.content，保留 blob URL 用于会话内预览（微信 WebView 兼容更好）
              // pendingContent（压缩后 base64）继续保留，用于跨刷新/跨会话恢复缩略图，
              // 不依赖后端 /api/... 是否可达
              console.log("上传成功:", data.data.url || data.data);
            } else {
              this.$set(file, "status", "failed");
              this.$set(file, "message", "上传失败");
              Toast(data.message || "上传失败，请重试");
            }
          } catch (e) {
            this.$set(file, "status", "failed");
            this.$set(file, "message", "上传失败");
          }
          this.$forceUpdate();
          resolve();
        };

        xhr.onerror = () => {
          this.$set(file, "status", "failed");
          this.$set(file, "message", "网络错误");
          Toast("上传失败，请重试");
          this.$forceUpdate();
          resolve();
        };

        xhr.ontimeout = () => {
          this.$set(file, "status", "failed");
          this.$set(file, "message", "上传超时");
          Toast("上传超时，请减小文件大小");
          this.$forceUpdate();
          resolve();
        };

        xhr.open("POST", baseUrl + "/aftersale/upload");
        xhr.send(formData);
      });
    },

    // === 回寄地址 ===
    pushAddress() {
      // 跳转前弹窗提示，确认后保存当前内容再跳转，避免返回时数据丢失
      Dialog.confirm({
        title: "跳转提示",
        message: "跳转前将自动保存已填内容，返回后可继续编辑。",
        confirmButtonText: "保存并跳转",
        cancelButtonText: "取消",
        confirmButtonColor: "#60bb46",
      })
        .then(() => {
          this.saveFormToLocal();
          this.$router.push({ name: "addressMana" });
        })
        .catch(() => {
          // 用户取消，不做处理
        });
    },

    // === 本地保存表单（不调接口） ===
    // 保留 content（base64 压缩预览）：服务端返回的 url 是相对路径，前端不能直接 <img src>，
    // 所以预览必须靠 content；恢复时优先用它显示缩略图
    // 优先带 content 保存；如果超过 localStorage 容量，降级为只存 url（保证文字数据不丢）
    saveFormToLocal() {
      try {
        const makeDraft = (withContent) => {
          const draft = cloneDeep(this.form);
          draft.serialItems.forEach((item) => {
            item.attachments = (item.attachments || [])
              // 已上传的保留；未完成但有缓存 base64 的（iOS 拍照后被杀场景）也保留，
              // 让 reload 后用户至少能看到缩略图并知道要重传
              .filter((a) =>
                (a.url && typeof a.url === "string") ||
                (a.pendingContent && typeof a.pendingContent === "string")
              )
              .map((a) => {
                // 分支一：上传已完成
                if (a.url && typeof a.url === "string") {
                  const entry = {
                    url: a.url,
                    file: {
                      name: a.file && a.file.name ? a.file.name : "file",
                      type:
                        a.file && a.file.type ? a.file.type : "image/jpeg",
                    },
                    status: "done",
                  };
                  if (withContent) {
                    // 优先用 pendingContent（压缩后 base64）：纯前端、不依赖后端图片可达
                    if (a.pendingContent && typeof a.pendingContent === "string") {
                      entry.content = a.pendingContent;
                    } else if (a.content && typeof a.content === "string") {
                      // 没有 base64 时降级：blob 出会话即失效，转成后端 /api/... 路径
                      if (a.content.indexOf("blob:") === 0) {
                        const fallback = this.resolveAttachmentUrl(a.url);
                        if (fallback) entry.content = fallback;
                      } else {
                        entry.content = a.content;
                      }
                    }
                  }
                  return entry;
                }
                // 分支二：上传未完成但有 base64 缓存（多见于 iOS 拍照后被微信杀页面）
                // 不带 content 的降级版本就不保留这类条目（避免 reload 出现无缩略图的空位）
                if (!withContent) return null;
                return {
                  file: {
                    name: a.file && a.file.name ? a.file.name : "file",
                    type:
                      a.file && a.file.type ? a.file.type : "image/jpeg",
                  },
                  content: a.pendingContent,
                  status: "failed",
                  message: "上传中断，请删除重传",
                };
              })
              .filter((a) => a !== null);
          });
          return draft;
        };
        try {
          localStorage.setItem("serviceDraft", JSON.stringify(makeDraft(true)));
        } catch (quotaErr) {
          // localStorage 容量超限（QuotaExceededError），降级为不带 content 的版本
          console.warn("草稿体积超限，降级为仅保存 url", quotaErr);
          localStorage.setItem("serviceDraft", JSON.stringify(makeDraft(false)));
        }
        localStorage.setItem("serviceAddress", JSON.stringify(this.address));
      } catch (e) {
        console.warn("saveFormToLocal 失败", e);
      }
    },

    // === 表单校验 ===
    validateForm() {
      if (!this.form.name.trim()) {
        Toast("请输入姓名");
        return false;
      }
      if (!this.form.phone.trim()) {
        Toast("请输入联系电话");
        return false;
      }
      if (!/^1[3-9]\d{9}$/.test(this.form.phone.trim())) {
        Toast("请输入正确的手机号");
        return false;
      }
      if (!this.form.email.trim()) {
        Toast("请输入邮箱");
        return false;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email.trim())) {
        Toast("请输入正确的邮箱");
        return false;
      }
      if (!this.form.company.trim()) {
        Toast("请输入单位/机构");
        return false;
      }
      if (!this.form.orderType) {
        Toast("请选择工单类型");
        return false;
      }
      // 每个设备的校验：许可申请时整段跳过（用户只需填软件 + 机器码）
      if (!this.isLicenseApply) {
        for (let i = 0; i < this.form.serialItems.length; i++) {
          const item = this.form.serialItems[i];
          if (!item.hasSerial) {
            Toast("请选择设备" + (i + 1) + "有无序列号");
            return false;
          }
          if (item.hasSerial === "yes" && !item.serialNo.trim()) {
            Toast("请填写设备" + (i + 1) + "的SN码（序列号）");
            return false;
          }
          if (!item.faultDesc || !item.faultDesc.trim()) {
            Toast("请填写设备" + (i + 1) + "的故障描述");
            return false;
          }
          if (
            item.hasSerial === "no" &&
            (!item.attachments || item.attachments.length === 0)
          ) {
            Toast("设备" + (i + 1) + "无序列号，请上传故障图片");
            return false;
          }
        }
      }
      // 许可申请校验
      if (this.form.orderType === "许可申请") {
        if (this.form.selectedSoftware.length === 0) {
          Toast("请选择需要授权的软件");
          return false;
        }
        for (let sw of this.form.selectedSoftware) {
          if (
            !this.form.machineCodes[sw] ||
            !this.form.machineCodes[sw].trim()
          ) {
            Toast("请填写" + sw + "的机器码");
            return false;
          }
        }
      }
      return true;
    },

    // === 保存草稿 ===
    async saveDraft() {
      console.log("saveDraft 被调用");
      // 先写一份本地草稿（带 content 预览，loadDraft 可直接还原缩略图）
      // 无论后端成功与否都先落地，避免"服务端成功但本地空" → 返回时图片破损
      this.saveFormToLocal();
      try {
        const submitData = this.buildSubmitData();
        const { code } = await saveDraftApi(submitData);
        Toast.success(code === "0000000" ? "草稿已保存" : "草稿已保存(本地)");
      } catch (e) {
        Toast.success("草稿已保存(本地)");
      }
    },

    // === 清理已下线软件项 ===
    // softwareOptions 调整后，老草稿里可能残留 SoloSW 等已下线项，
    // 直接复用旧值会导致 Checkbox 不显示但机器码输入框还在 → 体验异常
    // 这里统一过滤一次，selectedSoftware 与 machineCodes 都只保留当前软件清单
    pruneObsoleteSoftware() {
      const allowed = new Set(this.softwareOptions);
      if (Array.isArray(this.form.selectedSoftware)) {
        this.form.selectedSoftware = this.form.selectedSoftware.filter((sw) =>
          allowed.has(sw)
        );
      } else {
        this.form.selectedSoftware = [];
      }
      const cleanedCodes = {};
      this.softwareOptions.forEach((sw) => {
        cleanedCodes[sw] =
          (this.form.machineCodes && this.form.machineCodes[sw]) || "";
      });
      this.form.machineCodes = cleanedCodes;
    },

    // === 恢复草稿 ===
    async loadDraft() {
      // 优先恢复本地草稿（从地址页返回时本地草稿是最新的）
      const draft = localStorage.getItem("serviceDraft");
      if (draft) {
        try {
          const localData = JSON.parse(draft);
          this.form = { ...this.form, ...localData };
          if (!this.form.serialItems || this.form.serialItems.length === 0) {
            this.form.serialItems = [
              {
                serialNo: "",
                faultDesc: "",
                attachments: [],
                hasSerial: "yes",
                deviceModel: "",
                otherModel: "",
              },
            ];
          }
          this.form.serialItems.forEach((item) => {
            if (!item.attachments) item.attachments = [];
          });
          // 兼容历史草稿：把已下线的软件（例如 SoloSW）从勾选与机器码里清掉
          this.pruneObsoleteSoftware();
          console.log("草稿已从本地恢复");
        } catch (err) {
          console.warn("本地草稿恢复失败", err);
        }
      }
      // 恢复地址：仅在 Vuex 中没有地址时回填，
      // 避免从 addressMana 新选地址后被 localStorage 里的旧地址覆盖
      const currentAddr = this.$store.state.offici.address || {};
      if (!currentAddr.id) {
        const addr = localStorage.getItem("serviceAddress");
        if (addr) {
          try {
            const addrData = JSON.parse(addr);
            if (addrData && addrData.id) {
              this.$store.commit("offici/setAddress", addrData);
            }
          } catch (err) {
            console.warn("地址恢复失败", err);
          }
        }
      }
      // 本地没有草稿时，尝试从服务器恢复
      if (!draft) {
        try {
          const openid = localStorage.getItem("openId");
          if (!openid) return;
          const { data, code } = await getDraftApi({ openid });
          if (code === "0000000" && data) {
            if (data.name) this.form.name = data.name;
            if (data.phone) this.form.phone = data.phone;
            if (data.email) this.form.email = data.email;
            if (data.company) this.form.company = data.company;
            if (data.orderType) this.form.orderType = data.orderType;
            if (data.deviceModel) this.form.deviceModel = data.deviceModel;
            if (data.remark) this.form.remark = data.remark;
            // 恢复许可申请相关
            if (data.selectedSoftware) {
              this.form.selectedSoftware = data.selectedSoftware;
            }
            if (data.machineCodes) {
              this.form.machineCodes = {
                ...this.form.machineCodes,
                ...data.machineCodes,
              };
            }
            // 兼容历史草稿：把已下线的软件（例如 SoloSW）从勾选与机器码里清掉
            this.pruneObsoleteSoftware();
            // 恢复设备列表
            if (data.serialItems && data.serialItems.length > 0) {
              this.form.serialItems = data.serialItems.map((item) => ({
                serialNo: item.serialNo || "",
                faultDesc: item.faultDesc || "",
                hasSerial:
                  item.hasSerialNo === "有"
                    ? "yes"
                    : item.hasSerialNo === "无"
                      ? "no"
                      : "",
                deviceModel: item.deviceModel || "",
                otherModel: item.otherModel || "",
                attachments: (item.attachments || []).map((a) => ({
                  url: a.url || "",
                  // content 用于 Vant 显示缩略图，必须是可直接访问的 URL
                  content: this.resolveAttachmentUrl(a.url),
                  file: {
                    name: a.fileName || "file",
                    // 保留/推断 type，让 Vant 识别为图片渲染缩略图
                    type: "image/jpeg",
                  },
                  status: "done",
                })),
              }));
            }
            console.log("草稿已从服务器恢复");
          }
        } catch (e) {
          console.warn("从服务器加载草稿失败", e);
        }
      }
    },

    // === 构建提交数据 ===
    buildSubmitData() {
      const data = {
        openid: localStorage.getItem("openId"),
        name: this.form.name,
        phone: this.form.phone,
        email: this.form.email,
        company: this.form.company,
        orderType: this.form.orderType,
        deviceModel:
          this.form.deviceModel === "其他"
            ? this.form.otherModel
            : this.form.deviceModel,
        remark: this.form.remark,
        addressId: this.address.id || null,
      };

      // 构建序列号列表（每个设备独立型号+有/无序列号）
      data.serialItems = this.form.serialItems.map((item) => ({
        serialNo: item.hasSerial === "yes" ? item.serialNo : "",
        faultDesc: item.faultDesc,
        hasSerialNo: item.hasSerial === "yes" ? "有" : "无",
        deviceModel:
          item.deviceModel === "其他" ? item.otherModel : item.deviceModel,
        attachments: (item.attachments || []).map((a) => ({
          fileId: a.fileId || a.url || a.content,
          fileName:
            (item.serialNo ? item.serialNo + "_" : "") +
            (a.file ? a.file.name : "file"),
        })),
      }));

      // 许可申请：附加软件和机器码信息
      if (this.form.orderType === "许可申请") {
        data.selectedSoftware = this.form.selectedSoftware;
        data.machineCodes = {};
        this.form.selectedSoftware.forEach((sw) => {
          data.machineCodes[sw] = this.form.machineCodes[sw] || "";
        });
      }

      return data;
    },

    // === 提交工单 ===
    // === 重置表单到初始状态（提交成功后调用） ===
    // keep-alive 下组件实例不销毁，必须显式清空，否则用户回到本页会看到旧数据
    resetForm() {
      // 顺手释放还活着的 blob URL，避免内存堆积
      if (this.form && Array.isArray(this.form.serialItems)) {
        this.form.serialItems.forEach((item) => {
          (item.attachments || []).forEach((a) => {
            if (
              a &&
              a.content &&
              typeof a.content === "string" &&
              a.content.indexOf("blob:") === 0
            ) {
              try {
                URL.revokeObjectURL(a.content);
              } catch (e) {
                // ignore
              }
            }
          });
        });
      }
      this.form = createInitialForm();
    },

    async submitForm() {
      // 防止同步双击：网络往返之前可能连续两次进入这里，
      // 第一次还没把 loading 翻成 true 时第二次也能通过
      if (this.loading) return;
      console.log("submitForm 被调用");
      console.log("表单数据：", JSON.stringify(this.form));
      if (!this.validateForm()) {
        console.log("校验未通过");
        return;
      }
      console.log("校验通过，开始提交");

      this.loading = true;
      try {
        const submitData = this.buildSubmitData();
        console.log("提交数据：", JSON.stringify(submitData, null, 2));

        const res = await createNewAftersale(submitData);
        console.log("后端返回：", JSON.stringify(res));
        if (res.code !== "0000000") {
          Toast.fail(res.message || "提交失败");
          this.loading = false;
          return;
        }

        // 清除草稿
        localStorage.removeItem("serviceDraft");
        localStorage.removeItem("serviceAddress");
        this.$store.commit("offici/clearServiceForm");
        // 重置当前表单：keep-alive 下组件实例不销毁，
        // 不显式 reset 的话回到本页会看到上次提交的数据
        this.resetForm();

        this.$router.push({
          path: "/workOrderConfirm",
          query: { id: res.data || "" },
        });
      } catch (e) {
        Toast.fail("提交失败，请重试");
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
::-webkit-scrollbar {
  display: none;
}

/deep/.van-field__label {
  width: 60px;
  font-size: 13px;
  color: #666;
}

/deep/.van-cell {
  padding: 10px 12px;
  border-radius: 6px;
  background: #f9f9f9;
  margin-top: 8px;
}

/deep/.van-cell::after {
  display: none;
}

/deep/.van-radio__label {
  font-size: 13px;
}

/deep/.van-radio__icon--checked .van-icon {
  background-color: #60bb46;
  border-color: #60bb46;
}

.service-form {
  background: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 70px;

  &__content {
    padding: 12px;
  }

  // === Hero 头部 ===
  &__hero {
    background: #fff;
    border: none;
    border-radius: 14px;
    padding: 14px 16px 12px;
    margin-bottom: 12px;
    color: #333;
    position: relative;
    overflow: hidden;

    // 装饰背景
    &::before {
      content: "";
      position: absolute;
      top: -30px;
      right: -30px;
      width: 120px;
      height: 120px;
      border-radius: 50%;
      background: rgba(122, 182, 72, 0.06);
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -20px;
      left: -20px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background: rgba(122, 182, 72, 0.04);
    }

    &__brand {
      text-align: center;
      margin-bottom: 10px;
      position: relative;
      z-index: 1;
    }

    &__logo {
      width: 100px;
      height: auto;
      display: block;
      margin: 0 auto 2px;
    }

    &__title {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 1px;
    }

    &__subtitle {
      font-size: 10px;
      color: #999;
      letter-spacing: 2px;
      margin-top: 1px;
      text-transform: uppercase;
    }

    // 步骤条
    &__steps {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      z-index: 1;
    }

    &__step {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;

      &__img {
        width: 24px;
        height: 24px;
        margin-bottom: 4px;
        filter: drop-shadow(1px 2px 3px rgba(0, 0, 0, 0.25));
      }

      &__label {
        font-size: 10px;
        white-space: nowrap;
        letter-spacing: 0.5px;
      }
    }

    &__line {
      flex: 1;
      height: 1px;
      background: #ddd;
      margin: 0 4px;
      margin-bottom: 16px;
    }
  }

  &__group {
    background: rgba(255, 255, 255, 0.65);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 10px;
    padding: 14px;
    margin-bottom: 10px;
  }

  &__label {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin-bottom: 4px;

    .required {
      color: #ee0a24;
      margin-right: 2px;
    }
  }

  &__hint {
    font-size: 12px;
    color: #999;
    margin: 6px 0;
    display: flex;
    align-items: flex-start;
    gap: 4px;
  }

  // === 提示信息统一样式 ===
  &__hint-box {
    background: #f0fae6;
    border-radius: 8px;
    padding: 10px 12px;
    margin-top: 8px;

    &__item {
      display: flex;
      align-items: flex-start;
      gap: 6px;
      font-size: 12px;
      color: #60bb46;
      line-height: 1.6;

      &+& {
        margin-top: 6px;
        padding-top: 6px;
        border-top: 1px dashed rgba(112, 197, 27, 0.3);
      }

      &--link {
        cursor: pointer;
        text-decoration: underline;
      }

      &--sub {
        margin-top: 4px !important;
        padding-top: 0 !important;
        border-top: none !important;
      }

      &--warn {
        color: #d97706;
        background: #fff7ed;
        margin: 8px -12px -10px;
        padding: 10px 12px;
        border-radius: 0 0 8px 8px;
        border-top: 1px dashed rgba(217, 119, 6, 0.3) !important;
        line-height: 1.5;
        align-items: center;

        .van-icon {
          flex-shrink: 0;
          line-height: 1;
        }

        >span {
          flex: 1;
          line-height: 1.5;
        }
      }
    }
  }

  // === 序列号示意图弹窗 ===
  &__micro-notes {
    margin-top: 8px;
  }

  &__micro-note {
    font-size: 11px;
    line-height: 1.6;
    color: #9aa1ab;

    & + & {
      margin-top: 2px;
    }

    &__link {
      color: #7d8794;
      text-decoration: underline;
      text-underline-offset: 2px;
      cursor: pointer;
      margin-left: 4px;
    }

    &--warn {
      margin-top: 8px;
      color: #a57b37;
    }
  }

  &__sn-popup {
    padding: 20px 16px;

    &__title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      text-align: center;
      margin-bottom: 10px;
    }

    &__desc {
      font-size: 13px;
      color: #666;
      line-height: 1.6;
      margin-bottom: 12px;
    }

    &__img {
      width: 50%;
      display: block;
      margin: 0 auto;
      border-radius: 8px;
      border: 1px solid #eee;

      &--zoom {
        cursor: zoom-in;
        transition: transform 0.15s ease;

        &:active {
          transform: scale(0.98);
        }
      }
    }

    &__tip {
      font-size: 12px;
      color: #999;
      margin-top: 12px;
      text-align: center;
    }
  }

  &__select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    border-radius: 6px;
    padding: 10px 12px;
    margin-top: 8px;
    font-size: 14px;

    .placeholder {
      color: #c8c9cc;
    }
  }

  &__radio {
    margin-top: 10px;
    margin-right: 16px;
  }

  // === 工单类型卡片 ===
  &__type-item {
    background: #f9f9f9;
    border-radius: 8px;
    padding: 12px;
    margin-top: 10px;
    border: 1px solid transparent;
    transition: all 0.2s;

    &--active {
      background: #f0fae6;
      border-color: #60bb46;
    }

    &__name {
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }

    &__desc {
      font-size: 12px;
      color: #999;
      margin-top: 4px;
      line-height: 1.5;
    }
  }

  // === 许可申请区域 ===
  &__license {
    margin-top: 12px;

    &__label {
      font-size: 13px;
      font-weight: 500;
      color: #333;
      margin-bottom: 10px;

      .required {
        color: #ee0a24;
        margin-right: 2px;
      }
    }

    &__checkbox {
      margin-right: 20px;
      margin-bottom: 8px;

      /deep/.van-checkbox__icon--checked .van-icon {
        background-color: #60bb46;
        border-color: #60bb46;
      }
    }

    &__codes {
      margin-top: 10px;
    }

    &__code-item {
      background: #f9f9f9;
      border-radius: 8px;
      margin-bottom: 8px;

      /deep/.van-cell {
        background: #f9f9f9;
      }

      /deep/.van-field__label {
        width: 70px;
        color: #60bb46;
        font-weight: 500;
      }
    }

    &__hint-box {
      background: #f0fae6;
      border-radius: 8px;
      padding: 10px 12px;
      margin-top: 8px;
    }

    &__hint-item {
      display: flex;
      align-items: flex-start;
      gap: 6px;
      font-size: 12px;
      color: #60bb46;
      line-height: 1.6;

      &+& {
        margin-top: 6px;
        padding-top: 6px;
        border-top: 1px dashed rgba(96, 187, 70, 0.3);
      }

      &--link {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  // === 序列号区域 ===
  &__serial-item {
    background: #f9f9f9;
    border-radius: 8px;
    padding: 10px;
    margin-top: 10px;

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 4px;
    }

    &__index {
      font-size: 13px;
      font-weight: 500;
      color: #60bb46;
    }

    &__delete {
      font-size: 16px;
      color: #999;
      padding: 4px;
    }

    /deep/.van-cell {
      background: #fff;
    }

    // 每个设备下的上传区域
    &__upload {
      margin-top: 8px;
      padding: 0;

      &__label {
        font-size: 13px;
        color: #323233;
        margin-bottom: 6px;
      }

      /deep/.van-uploader__upload {
        background: #fff;
        border-radius: 8px;
      }

      /deep/.van-uploader__preview-delete {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.6);
        top: 4px;
        right: 4px;
        display: flex !important;
        align-items: center;
        justify-content: center;
        z-index: 10;
      }

      /deep/.van-uploader__preview-delete-icon {
        font-size: 12px;
        transform: scale(1);
        position: static;
      }
    }
  }

  &__add-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-top: 10px;
    padding: 10px;
    border: 1px dashed #60bb46;
    border-radius: 8px;
    color: #60bb46;
    font-size: 13px;

    &:active {
      background: #f0fae6;
    }
  }

  // === 回寄地址 ===
  &__address {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f9f9f9;
    border-radius: 8px;
    padding: 12px;
    margin-top: 8px;

    &__info {
      flex: 1;
    }

    &__line {
      font-size: 14px;
      color: #323233;
    }

    &__contact {
      font-size: 14px;
      color: #323233;
      margin-top: 4px;
    }

    &__empty {
      font-size: 14px;
      color: #c8c9cc;
    }
  }

  // === 温馨提示 ===
  &__tips {
    background: #fff;
    border-radius: 10px;
    padding: 14px;
    margin-bottom: 10px;

    &__title {
      color: #999;
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 10px;
    }

    &__list {
      &__item {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        color: #999;
        font-size: 12px;
        line-height: 1.7;

        &+& {
          margin-top: 8px;
        }
      }

      &__dot {
        width: 5px;
        height: 5px;
        min-width: 5px;
        border-radius: 50%;
        background: #ccc;
        margin-top: 7px;
      }
    }

    &__note {
      color: #bbb;
      font-size: 11px;
      margin-top: 14px;
      padding-top: 10px;
      border-top: 1px solid #f0f0f0;
      line-height: 1.6;
    }
  }

  // === 底部按钮 ===
  &__footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    gap: 12px;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
    z-index: 100;

    &__draft {
      flex: 1;
      height: 40px;
      border: 1px solid #60bb46;
      border-radius: 90px;
      color: #60bb46;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s ease, opacity 0.2s ease;

      &:active {
        background: #f0fae6;
      }

      &--disabled {
        opacity: 0.5;
        pointer-events: none;
      }
    }

    &__submit {
      flex: 1;
      height: 40px;
      background: #60bb46;
      border-radius: 90px;
      color: #fff;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      transition: background 0.2s ease, transform 0.15s ease,
        box-shadow 0.2s ease;

      &:active {
        background: #50a336;
      }

      // 2026 风：渐变 + 微动画 + 流光，明确告诉用户"我在做事"
      &--loading {
        pointer-events: none;
        background: linear-gradient(
          120deg,
          #60bb46 0%,
          #6ec53f 45%,
          #84d65a 50%,
          #6ec53f 55%,
          #60bb46 100%
        );
        background-size: 200% 100%;
        animation: submit-shimmer 1.4s linear infinite;
        box-shadow: 0 4px 14px rgba(96, 187, 70, 0.32);
        transform: translateY(-1px);
      }
    }
  }
}

@keyframes submit-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

// === 2026 现代 App 风格提示卡 ===
.tip-stack {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
}

.tip-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #ffffff;
  border: 1px solid rgba(17, 24, 39, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(17, 24, 39, 0.03);
  transition: background 0.15s ease, transform 0.1s ease;
  -webkit-tap-highlight-color: transparent;

  &__icon {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    color: #fff;

    &--green {
      background: linear-gradient(135deg, #6ec53f 0%, #60bb46 100%);
      box-shadow: 0 2px 4px rgba(96, 187, 70, 0.25);
    }

    &--amber {
      background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
      box-shadow: 0 2px 4px rgba(217, 119, 6, 0.25);
    }
  }

  &__body {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-size: 13px;
    font-weight: 600;
    color: #111827;
    line-height: 1.35;
    letter-spacing: 0.1px;
  }

  &__desc {
    margin-top: 2px;
    font-size: 11.5px;
    color: #6b7280;
    line-height: 1.5;
    letter-spacing: 0.1px;
  }

  &__chevron {
    flex-shrink: 0;
    color: #9ca3af;
  }

  &--link {
    cursor: pointer;

    &:active {
      background: #f9fafb;
      transform: scale(0.997);
    }

    .tip-card__title {
      color: #111827;
    }
  }

  &--warn {
    background: linear-gradient(180deg, #fffbf5 0%, #fff7ed 100%);
    border-color: rgba(245, 158, 11, 0.18);

    .tip-card__title {
      color: #92400e;
    }

    .tip-card__desc {
      color: #b45309;
    }
  }
}

</style>
